import { ForwardedRef, forwardRef, ReactNode, useCallback } from "react"
import { PopoverButton } from "./PopoverButton"
import { Hash, Move, Palette, PersonStanding, ToggleRight } from "lucide-react"
import { ColorPickerButton } from "./ColorPickerButton"
import { Color, Expr } from "../../shared/Expr"
import { useCurrentPage } from "../hooks/useCurrentPage"
import { ToolbarButton, ToolbarIconButton } from "./Toolbar"
import { NumberPickerButton } from "./NumberPickerButton"
import { TLShapeId, useEditor } from "tldraw"
import { Transform } from "../../shared/StickerShape"
import { Slider, styled } from "@mui/material"
import { toNumber } from "lodash"
import { ParameterizableControl } from "./ParameterializableControl"

type Props<T extends HTMLElement> = {
  shapeId: TLShapeId
  children: (
    clickHandler: (event: React.MouseEvent<T>) => void,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => ReactNode
  onChange: (transformation: keyof Transform, value: Expr<number>) => void
  num?: Expr<number>
  onChangeNum?: (num: Expr<number>) => void
  transform?: Transform
  isClone?: boolean
}

export const defaultTransformation: Transform = {
  translateX: Expr.lit(0),
  translateY: Expr.lit(0),
  scaleX: Expr.lit(1),
  scaleY: Expr.lit(1),
  rotate: Expr.lit(0),
}

const StyledDiv = styled("div")({
  display: "flex",
  padding: "4px 8px",
  gap: 4,
  borderRadius: 99,
  alignItems: "stretch",
  background: "rgb(210, 230, 255)",
  border: "1px solid rgb(170, 210, 255)",
  fontSize: 14,
  fontWeight: 500,
})

const TransformButton = (
  name: string,
  clickHandler: React.MouseEventHandler<HTMLButtonElement>,
  ref: React.LegacyRef<HTMLButtonElement>,
) => (
  <ToolbarButton ref={ref} onClick={clickHandler}>
    <StyledDiv>
      <div>{name}=0</div>
    </StyledDiv>
  </ToolbarButton>
)

export const TransformationButton = forwardRef<
  HTMLButtonElement,
  Props<HTMLButtonElement>
>(function TransformationButton(
  { transform, shapeId, onChange, children, onChangeNum, num, isClone },
  ref,
) {
  const page = useCurrentPage()
  const editor = useEditor()
  const pageMeta = page.meta

  const shape = editor.getShape(shapeId)!

  // const transform = (shape.props as { transform: Record<string, Expr<number>> })
  //   ?.transform

  if (!transform) return null
  return (
    <PopoverButton
      ref={ref}
      renderButton={(clickHandler, ref) => children(clickHandler, ref)}
    >
      {() => (
        <>
          <div
            style={{
              display: "flex",
              gap: 4,
              flexDirection: "column",
              padding: 4,
            }}
          >
            {Object.keys(defaultTransformation).map((k) => {
              return (
                <div>
                  {k}=
                  <NumberPickerButton
                    number={transform[k as keyof Transform]} //(p.value as Expr<Color>) ?? 0}
                    onChange={(number) =>
                      onChange(k as keyof Transform, number)
                    }
                  >
                    {(clickHandler, ref, number) => (
                      <button
                        ref={ref}
                        onClick={clickHandler}
                        style={{
                          width: 30,
                          borderRadius: 2,
                        }}
                      >
                        {Expr.evaluate(number, page.meta.parameterValues)}
                      </button>
                    )}
                  </NumberPickerButton>
                </div>
              )
            })}
            {/* Todo(Alex): get this working */}
            {/* <ParameterizableControl
              title="Num"
              type="number"
              value={null}
              onChange={onChangeNum}
            ></ParameterizableControl> */}
          </div>
        </>
      )}
    </PopoverButton>
  )
})
